module.exports = __webpack_public_path__ + "img/itirapina.a0a2e6c2.png";